import script from "./Agreement.vue?vue&type=script&setup=true&lang=js"
export * from "./Agreement.vue?vue&type=script&setup=true&lang=js"

import "./Agreement.vue?vue&type=style&index=0&id=e9a319cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9a319cc"]])

export default __exports__